import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import { ref } from 'vue'

  //=== Data
  
export default /*#__PURE__*/_defineComponent({
  __name: 'MultiStep',
  props: {
    stepsNumber: {
      type: Number,
      default: 1,
    }
  },
  setup(__props, { expose: __expose }) {

  const currentStep = ref(1)
  const lastStep = ref(1)
  const props = __props

  const nextStep = () => {
    console.log(currentStep.value, lastStep.value)
    lastStep.value = currentStep.value
    currentStep.value++
  }

  __expose({
    nextStep
  })


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.stepsNumber, (step) => {
    return (_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(`step-${step}`),
      key: step
    }, [
      (step === currentStep.value)
        ? _renderSlot(_ctx.$slots, step, { key: 0 })
        : _createCommentVNode("", true)
    ], 2))
  }), 128))
}
}

})